import React from 'react';
import { Link } from 'react-router-dom';
import '../styles/ExtraPages.css';

const games = [
  {
    name: 'Idea Match',
    path: '/games/idea-match',
    summary: 'Match startup ideas with real customer problems before the timer runs out.',
  },
  {
    name: 'Pricing Challenge',
    path: '/games/pricing-challenge',
    summary: 'Pick smart prices based on cost and target margin to maximize points.',
  },
  {
    name: 'Budget Builder',
    path: '/games/budget-builder',
    summary: 'Build a monthly startup budget and keep your runway healthy.',
  },
];

const GamesHubPage = () => {
  return (
    <main className="extra-page-shell">
      <section className="extra-page-hero">
        <p className="extra-kicker">Game Lab</p>
        <h1>Play, decide, and level up your business instincts.</h1>
        <p>
          These mini-games are fast to play and built to reinforce key entrepreneurship concepts.
        </p>
      </section>

      <section className="module-cards">
        {games.map((game) => (
          <article className="module-card" key={game.name}>
            <h2>{game.name}</h2>
            <p>{game.summary}</p>
            <Link to={game.path} className="extra-btn solid inline">Start Game</Link>
          </article>
        ))}
      </section>

      <div className="extra-actions">
        <Link to="/modules" className="extra-btn light">See Modules</Link>
      </div>
    </main>
  );
};

export default GamesHubPage;
